import React, { useState } from 'react';
import './TermsOfServicePage.css';
import CommonHeader from '../components/CommonHeader';
import Footer from '../components/Footer';

const TermsOfServicePage = () => {
  const [activeSection, setActiveSection] = useState('agreement');

  const sections = [
    { id: 'agreement', label: '1. Acceptance of Terms' },
    { id: 'accounts', label: '2. User Accounts & Security' },
    { id: 'curriculum', label: '3. Intellectual Property' },
    { id: 'conduct', label: '4. User Conduct & Play' },
    { id: 'termination', label: '5. Account Termination' },
    { id: 'liability', label: '6. Limitation of Liability' },
    { id: 'changes', label: '7. Changes to Terms' },
  ];

  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="landing-wrapper">
      <CommonHeader />
      
      <main className="tos-container">
        {/* PAGE TITLE BANNER */}
        <header className="tos-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: July 2026</p>
        </header>

        <div className="tos-layout">
          {/* SIDEBAR NAVIGATION */}
          <aside className="tos-sidebar">
            <nav className="tos-nav">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className={`tos-nav-link ${activeSection === section.id ? 'active' : ''}`}
                >
                  {section.label}
                </button>
              ))}
            </nav>
          </aside>

          {/* LEGAL TEXT CONTENT CONTAINER */}
          <article className="tos-content">
            <section id="agreement" className="tos-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                Welcome to Knolup. By accessing or using our interactive quiz platform, you agree to comply with and be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
              <p>
                Our services are designed to support primary and secondary educational workflows. If you are using the service as a parent or legal guardian on behalf of a student, you agree to be bound by these terms regarding that student's use of the platform.
              </p>
            </section>

            <section id="accounts" className="tos-section">
              <h2>2. User Accounts & Security</h2>
              <p>
                To access certain core curriculum features, interactive progress reports, or reward tracking dashboards, you must register for an account. You are solely responsible for maintaining the confidentiality of your credentials.
              </p>
              <p>
                You agree to notify us immediately of any unauthorized use of your account. Knolup cannot and will not be liable for any loss or damage arising from your failure to comply with this security obligation.
              </p>
            </section>

            <section id="curriculum" className="tos-section">
              <h2>3. Intellectual Property</h2>
              <p>
                All materials provided on Knolup—including but not limited to custom multiple-choice question datasets, curriculum structures across mathematics, history, and geography, custom interface codebases, digital badges, graphics, and printable fun worksheets—are the exclusive property of Knolup or its content suppliers.
              </p>
              <p>
                You are granted a limited, personal, non-exclusive, non-transferable license to access educational modules for personal, school-aligned learning. Downloading printable assets is restricted to active accounts for intended educational tracking layouts only.
              </p>
            </section>

            <section id="conduct" className="tos-section">
              <h2>4. User Conduct & Play</h2>
              <p>
                Knolup is built to keep learning safe, supportive, and playful. Users agree not to abuse gamified mechanisms, manipulate leaderboard scoring parameters, execute automated extraction scripts or scraping bots on question parameters, or intentionally trigger platform errors.
              </p>
            </section>

            <section id="termination" className="tos-section">
              <h2>5. Account Termination</h2>
              <p>
                We reserve the right, without notice and at our sole discretion, to terminate or suspend your account or restrict your access to platforms for violations of these Terms of Service or behavior that compromises the security of other student portals.
              </p>
            </section>

            <section id="liability" className="tos-section">
              <h2>6. Limitation of Liability</h2>
              <p>
                Knolup provides its curriculum-based quiz modules on an "as is" and "as available" basis. We do not warrant that the service will be entirely error-free, continuous, or completely uninterrupted. In no event shall Knolup be liable for any direct, indirect, or incidental damages resulting from your use or inability to use the learning platform.
              </p>
            </section>

            <section id="changes" className="tos-section">
              <h2>7. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Changes take effect immediately upon being published within this document link layout. Your continued engagement with our home dashboard or quiz systems after updates are posted constitutes complete acceptance of the updated terms.
              </p>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;